module.exports = __webpack_public_path__ + "img/home.6fba66df.png";